import React, { useEffect, useState } from "react";
import { Alert, Card, Col, Container, Row, Spinner } from "react-bootstrap";
import './home.css';
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../index";


export default function Home() {
    const navigate = useNavigate();

    const [permissions, setPermissions] = useState({
        any: true,
        owner: false,
        spectator: false,
        player: false,
        admin: false,
        tester: false,
    });
    const [isLoading, setIsLoading] = useState(true);
    const [error] = useState<string | null>(null);

    useEffect(() => {

        api
            .post('/auth/check/perms', {}, { withCredentials: true })
            .then((res) => {
                const perms = res.data.perms;
                setPermissions({
                    any: true,
                    player: perms.includes('p'),
                    spectator: perms.includes('s'),
                    owner: perms.includes('o'),
                    admin: perms.includes('a'),
                    tester: perms.includes('t'),
                });
            })
            .catch((e) => {
                localStorage.removeItem("userData");
                navigate("/login");
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [navigate]);

    const dashboardItems = [
        {
            text: 'My Decks',
            description: 'Manage, create, and view your card decks.',
            location: '/decks',
            condition: permissions.any
        },
        {
            text: 'Play Game',
            description: 'Start or join a new game with other players.',
            icon: 'bi-controller',
            location: '/games',
            condition: permissions.player,
        },
        {
            text: 'Owner Operations',
            description: 'Perform advanced administrative tasks.',
            location: '/owner',
            condition: permissions.owner,
        },
        {
            text: 'Admin Operations',
            description: 'Manage users, content, and system settings.',
            location: '/admin',
            condition: permissions.admin || permissions.owner,
        },
        {
            text: 'Match History',
            description: 'View a list of previous matches.',
            location: '/matchHistory',
            condition: permissions.player,
        },
        {
            text: 'Demos',
            description: 'Developer demo displays.',
            location: '/demo',
            condition: permissions.admin || permissions.owner,
        },
        // {
        //     text: 'Spectate Game',
        //     description: 'Watch ongoing games as a spectator.',
        //     location: '/spectate', 
        //     condition: permissions.spectator,
        // },
        {
            text: 'How To Play',
            description: 'Rules and instructions.',
            location: '/howToPlay',
            condition: permissions.admin,
        },
        // {
        //     text: 'Settings',
        //     description: 'Update your profile and account preferences.',
        //     location: '/settings',
        //     condition: permissions.any, 
        // },
        // {
        //     text: 'Feedback',
        //     description: 'Submit feedback about the game.',
        //     location: '/home/feedback',
        //     condition: permissions.any, 
        // },
        // {
        //     text: 'Developer Notes',
        //     description: 'Patch notes and other developer messages.',
        //     location: '/home/DevNotes', 
        //     condition: permissions.any,
        // },
    ];

    if (isLoading) {
        return (
            <Container className='py-5 d-flex flex-grow-1 justify-content-center align-items-center'>
                <Spinner animation='border' role='status' className='me-2' />
                <span>Loading Dashboard...</span>
            </Container>
        );
    }

    if (error) {
        return (
            <Container className='py-5 d-flex flex-grow-1 justify-content-center align-items-center'>
                <Alert variant='danger'>{error}</Alert>
            </Container>
        );
    }

    // Filter out items the user doesn't have permission for
    const visibleItems = dashboardItems.filter((item) => item.condition);

    return (
        <Container className='py-5 d-flex flex-column flex-grow-1 justify-content-start align-items-center bg-transparent'>
            {visibleItems.length === 0 && (
                <Alert variant='info' className='mt-3'>
                    You don't currently have access to any features. Please contact support if this is
                    unexpected.
                </Alert>
            )}

            <Row className='g-4 justify-content-center' style={{ width: '100%' }}>
                {visibleItems.map((item) => (
                    <Col key={item.text} xs={12} sm={6} md={4} lg={3} className='d-flex'>
                        <Card className='h-100 shadow-sm transition-hover-lift w-100'>
                            <Card.Body className='d-flex flex-column'>
                                <div className='d-flex align-items-center mb-3'>
                                    <h3 className='mb-0'>{item.text}</h3>
                                </div>
                                <Card.Text className='text-muted flex-grow-1'>{item.description}</Card.Text>
                                <Link to={item.location} className='btn btn-outline-primary mt-auto'>
                                    Go
                                </Link>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
}